import React, {useContext, useEffect, useRef, useState} from 'react';
import {LayoutContext} from "../../../../../../layout/context/LayoutContext";
import {Toast} from "primereact/toast";
import {usePagination} from "../../../../../../layout/hooks/usePagination";
import {useFetch} from "../../../../../../layout/hooks/useFetch";
import {webInfo} from "../../../../../../utils/webInfo";
import callToast, {
    handleChangeData,
    mergeWithSelected,
    postData,
    validateFormFields
} from "../../../../../../utils/helper";
import {Button} from "primereact/button";
import PageHeading from "../../../../../../Components/PageHeading";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import Label from "../../../../../../Components/Label";
import {InputText} from "primereact/inputtext";
import {Vehicle} from "../../../../../../types/demo";
import {InputNumber} from "primereact/inputnumber";
import {Dropdown} from "primereact/dropdown";


const ManageVehicles = () => {
    const initialState: Vehicle = {
        vehicle_type_id : null ,
        vehicle_brand_id: null,
        model:'',
        serial_number: '',
        seat_capacity: null,
        cc: null,
        engine_number: '',
        chassis_number: '',
    };
    const {accessToken} = useContext(LayoutContext)
    const [refresh, setRefresh] = useState<boolean>(false);
    const [formData, setFormData] = useState<Vehicle>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const toast = useRef<Toast | null>(null)
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const [modal, setModal] = useState<boolean>(false);
    const [updatedId, setUpdatedId] = useState<number | null>(null);

    const [vehicleTypeNameFilter, setVehicleTypeNameFilter] = useState<string>('');
    const [vehicleBrandNameFilter, setVehicleBrandNameFilter] = useState<string>('');
    const [vehicleTypeOptions, setVehicleTypeOptions] = useState<{id:number, name:string}[]>([]);
    const [vehicleBrandOptions, setVehicleBrandOptions] = useState<{id:number, name:string}[]>([]);

    // pagination
    const {page, limitData, handlePageChange} = usePagination();

    // endpoint
    const mainTitle = "Manage Vehicles"
    const tableDataEndpointUrl = `/vehicle?page=${page} `
    const submitFormEndpointUrl = updatedId ? `/vehicle/${updatedId}` : "/vehicle";

    // fetch data
    const {
        data: tableDataList,
        totalData, loading
    } = useFetch(tableDataEndpointUrl, [refresh])

    // fetch dorpdown data
    const { data: vehicleTypeRawData } = useFetch(
        `/vehicle-types?page=1&per_page=10${vehicleTypeNameFilter ? `&name=${vehicleTypeNameFilter}` : ''}`,
        [vehicleTypeNameFilter]
    );

    useEffect(() => {
        if (vehicleTypeRawData) {
            const modifiedData = vehicleTypeRawData?.map((item: any) => ({
                id: item?.id,
                name: item?.name
            }));
            setVehicleTypeOptions(mergeWithSelected(modifiedData, formData?.vehicle_type_id));
        }
    }, [vehicleTypeRawData, formData?.vehicle_type_id]);

    const { data: vehicleBrandRawData } = useFetch(
        `/vehicle-brands?page=1&per_page=10${vehicleBrandNameFilter ? `&name=${vehicleBrandNameFilter}` : ''}`,
        [vehicleBrandNameFilter]
    );

    useEffect(() => {
        if (vehicleBrandRawData) {
            const modifiedData = vehicleBrandRawData?.map((item: any) => ({
                id: item?.id,
                name: item?.name
            }));
            setVehicleBrandOptions(mergeWithSelected(modifiedData, formData?.vehicle_brand_id));
        }
    }, [vehicleBrandRawData, formData?.vehicle_brand_id]);


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const validationRules = [
            { field: 'cc', label: 'CC' },
            { field: 'seat_capacity', label: 'Seat Capacity' },
            { field: 'vehicle_brand_id', label: 'Vehicle Brand' },
            { field: 'vehicle_type_id', label: 'Vehicle Type' },
            { field: 'model', label: 'Model Name' },
            { field: 'serial_number', label: 'Serial Number' },
            { field: 'engine_number', label: 'Engine Number' },
            { field: 'chassis_number', label: 'Chassis Number' },
        ];

        if (!validateFormFields(formData, validationRules, toast)) return;

        const payload =  {
            model: formData.model.replace(/\s+/g, ' ').trim(),
            cc: formData.cc,
            seat_capacity: formData.seat_capacity,
            vehicle_brand_id: formData.vehicle_brand_id?.id,
            vehicle_type_id: formData.vehicle_type_id?.id,
            serial_number: formData.serial_number.replace(/\s+/g, ' ').trim(),
            engine_number: formData.engine_number.replace(/\s+/g, ' ').trim(),
            chassis_number: formData.chassis_number.replace(/\s+/g, ' ').trim(),
        };

        console.log("submitted payload",payload);
        console.log('submitted form data', formData)

        try {
            setIsSubmitting(true);
            const response = await fetch(`${webInfo?.baseUrl}${submitFormEndpointUrl}`, postData("PUT", accessToken, payload));


            if (response.ok) {
                callToast(toast, true, `Vehicle ${updatedId ? 'updated' : 'created'} successfully`);
                setFormData(initialState)
                setModal(false)
                setUpdatedId(null)
                setVehicleBrandNameFilter('')
                setVehicleTypeNameFilter('')
                setRefresh(!refresh);
                return;
            }else{
                const resData = await response.json();
                callToast(toast, false, resData.error);
            }

        } catch (err) {
            console.error('Failed to update', err);
        }finally {
            setIsSubmitting(false);
        }

    }

    // row edit template
    const actionTemplate = (rowData: any) => {
        console.log('rowData', rowData)
        return (
            <div className={'flex align-items-center justify-content-end'}>
                <Button icon={'pi pi-pencil'} className={'border-rounded w-2rem h-2rem'} onClick={() => {
                    setModal(true)
                    setUpdatedId(rowData?.id)
                    setVehicleBrandNameFilter('')
                    setVehicleTypeNameFilter('')
                    setFormData({
                        vehicle_type_id : rowData?.vehicle_type ,
                        vehicle_brand_id: rowData?.vehicle_brand,
                        model: rowData?.model,
                        serial_number: rowData?.serial_number,
                        seat_capacity: rowData?.seat_capacity,
                        cc: rowData?.cc,
                        engine_number: rowData?.engine_number,
                        chassis_number: rowData?.chassis_number,
                    })
                    // setFormData({ name: rowData.name});

                }} outlined/>
            </div>
        )
    }

    const identificationNumberBodyTemplate = (rowData: any) => {
        return (
            <div>
                <div><strong>Serial:</strong> {rowData.serial_number || '-'}</div>
                <div><strong>Engine:</strong> {rowData.engine_number || '-'}</div>
                <div><strong>Chassis:</strong> {rowData.chassis_number || '-'}</div>
            </div>
        );
    };
    // Type & Brand column template
    const typeBrandBodyTemplate = (rowData: any) => {
        return (
            <div className="flex flex-column gap-1">
                <span className="font-semibold text-900 text-sm">
                    {rowData.vehicle_type?.name || rowData.vehicle_type?.vehicle_type?.name || '-'}
                </span>
                <span className="text-700 text-xs">
                    {rowData.vehicle_brand?.name || rowData.vehicle_brand?.vehicle_brand?.name || '-'}
                </span>
            </div>
        );
    }
    return (
        <div className={"card"}>
            <Toast ref={toast}/>
            <PageHeading title={mainTitle}
                         isCreate={true}
                         createFunction={() => setModal(true)}
                         back={true}
            />

            <DataTable
                value={tableDataList}
                dataKey="id"
                tableStyle={{minWidth: '50rem'}}
                paginator={tableDataList?.length > 0}
                lazy
                first={(page - 1) * limitData}
                rows={limitData}
                totalRecords={totalData}
                loading={loading}
                onPage={handlePageChange}
            >
                <Column
                    field="model"
                    header="Model"
                    style={{width: '25%'}}
                    headerClassName={"white-space-nowrap"}/>
                <Column
                    field="serial_number"
                    header="Indentification Numbers"
                    style={{width: '25%'}}
                    headerClassName={"white-space-nowrap"}
                    body={identificationNumberBodyTemplate}
                />
                <Column
                    field="vehcile_brand"
                    header="Type & Brand"
                    style={{width: '25%'}}
                    headerClassName={"white-space-nowrap"}
                    body={typeBrandBodyTemplate}
                />
                <Column
                    field="seat_capacity"
                    header="Seat Capacity"
                    style={{width: '25%'}}
                    headerClassName={"white-space-nowrap"}
                />



                <Column header={"Action"} rowEditor={true}
                        bodyStyle={{textAlign: 'center'}}
                        body={actionTemplate}
                        headerClassName={"flex justify-content-end"}
                />

            </DataTable>

            <Dialog visible={modal}
                    style={{width: "50rem"}}
                    headerClassName="text-800 font-semibold text-xl"
                    header={updatedId ? `Edit ${mainTitle}` : `New ${mainTitle}`}
                    breakpoints={{"960px": "75vw", "640px": "90vw"}}
                    onHide={() => {
                        setUpdatedId(null)
                        setModal(false)
                        setVehicleBrandNameFilter('')
                        setVehicleTypeNameFilter('')
                        setFormData(initialState)
                    }}
            >
                <div>
                    <form className={''}
                          onSubmit={handleSubmit}
                    >
                        <div className="grid ">
                            <div className="col-12  md:col-6">
                                <Label label={"Model Name"} required={!updatedId}/>
                                <InputText
                                    id="model"
                                    value={formData.model}
                                    size={100}
                                    name={"model"}
                                    onChange={(e) => handleChangeData('model', e.target.value, formData, setFormData)}
                                    placeholder={"Enter model name"}
                                    className={`w-full`}
                                />
                            </div>
                        </div>
                        <div className="grid mt-2">
                            <div className="col-12  md:col-4">
                                <Label label={"CC"} required={!updatedId}/>
                                <InputNumber
                                    id="cc"
                                    value={formData.cc}
                                    name={"cc"}
                                    onValueChange={(e) => handleChangeData('cc', e.value, formData, setFormData)}
                                    placeholder={"Enter CC"}
                                    className={`w-full p-fluid`}
                                />
                            </div>
                            <div className="col-12  md:col-4">
                                <Label label={"Seat Capacity"} required={!updatedId}/>
                                <InputNumber
                                    id="seat_capacity"
                                    value={formData.seat_capacity}
                                    name={"seat_capacity"}
                                    onValueChange={(e) => handleChangeData('seat_capacity', e.value, formData, setFormData)}
                                    placeholder={"Enter seat capacity"}
                                    className={`w-full p-fluid`}
                                />
                            </div>
                        </div>
                        <div className="grid mt-2">
                            <div className="col-12  md:col-5">
                                <Label label={"Vehicle brand"} required={!updatedId}/>
                                <Dropdown
                                    options={vehicleBrandOptions? vehicleBrandOptions : []}
                                    optionLabel="name"
                                    id="vehicle_brand_id"
                                    name={`vehicle_brand_id`}
                                    className={`w-full`}
                                    value={formData?.vehicle_brand_id}
                                    onChange={(e) => handleChangeData('vehicle_brand_id', e.value, formData, setFormData)}
                                    placeholder="Select vehicle brand"
                                    filter
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setVehicleBrandNameFilter(e.filter)
                                        }, 500);

                                        if (vehicleBrandRawData) {
                                            const modifiedData = vehicleBrandRawData.map((item: any) => ({
                                                id: item?.id,
                                                name: item?.name
                                            }));
                                            setVehicleBrandOptions(modifiedData);
                                        }
                                    }}
                                    showClear
                                    showFilterClear
                                />
                            </div>
                            <div className="col-12  md:col-5">
                                <Label label={"Vehicle type"} required={!updatedId}/>
                                <Dropdown
                                    options={vehicleTypeOptions? vehicleTypeOptions : []}
                                    id="vehicle_type_id"
                                    optionLabel="name"
                                    name={`vehicle_type_id`}
                                    className={`w-full`}
                                    value={formData?.vehicle_type_id}
                                    onChange={(e) => handleChangeData('vehicle_type_id', e.value, formData, setFormData)}
                                    placeholder="Select vehicle type"
                                    filter
                                    onFilter={(e) => {
                                        if (timeoutRef?.current) {
                                            clearTimeout(timeoutRef.current);
                                        }
                                        timeoutRef.current = setTimeout(() => {
                                            setVehicleTypeNameFilter(e.filter)
                                        }, 500);

                                        if (vehicleTypeRawData) {
                                            const modifiedData = vehicleTypeRawData.map((item: any) => ({
                                                id: item?.id,
                                                name: item?.name
                                            }));
                                            setVehicleTypeOptions(modifiedData);
                                        }
                                    }}
                                    showClear
                                    showFilterClear
                                />
                            </div>
                        </div>
                        <div className="grid mt-2">
                            <div className="col-12  md:col-4">
                                <Label label={"Serial Number"} required={!updatedId}/>
                                <InputText
                                    id="serial_number"
                                    value={formData.serial_number}
                                    size={100}
                                    name={"serial_number"}
                                    onChange={(e) => handleChangeData('serial_number', e.target.value, formData, setFormData)}
                                    placeholder={"Enter serial number"}
                                    className={`w-full`}
                                />
                            </div>
                            <div className="col-12  md:col-4">
                                <Label label={"Engine Number"} required={!updatedId}/>
                                <InputText
                                    id="engine_number"
                                    value={formData.engine_number}
                                    size={100}
                                    name={"engine_number"}
                                    onChange={(e) => handleChangeData('engine_number', e.target.value, formData, setFormData)}
                                    placeholder={"Enter engine number"}
                                    className={`w-full`}
                                />
                            </div>
                            <div className="col-12  md:col-4">
                                <Label label={"Chassis Number"} required={!updatedId}/>
                                <InputText
                                    id="chassis_number"
                                    value={formData.chassis_number}
                                    size={100}
                                    name={"chassis_number"}
                                    onChange={(e) => handleChangeData('chassis_number', e.target.value, formData, setFormData)}
                                    placeholder={"Enter chassis number"}
                                    className={`w-full`}
                                />
                            </div>
                        </div>





                        <div className="flex gap-2 mt-2">
                            <Button
                                type="submit"
                                label={updatedId ? 'Update' : "Create"}
                                className="p-button-primary"
                                size={'small'}
                                loading={isSubmitting}
                            />
                        </div>
                    </form>
                </div>
            </Dialog>

        </div>
    );
};

export default ManageVehicles;

